// Última modificación: 27/10/2025

/**
 * Type of data source
 * @example "MQTT"
 */
export enum SourceTypeEnum {
	MQTT = "MQTT",
	OPCUA = "OPCUA",
	KAFKA = "KAFKA",
	POSTGRESQL = "POSTGRESQL",
	QUALITY_RULE = "QUALITY_RULE",
	PROFILING = "PROFILING",
	SLEEPER = "SLEEPER",
	ISO_ARTIFACT = "ISO_ARTIFACT",
	ISO_DATASET = "ISO_DATASET",
}
